import CertificationRequestQ from '@/queries/CertificationRequestQ'
import TopicQ from '@/queries/TopicQ'
import WorldQ from '@/queries/WorldQ'
import { SQL, type SQLFragment } from '@/client/query'

import { LevelRequirementStatus } from '../enum'

export default function getCertificationQuery({
  variant,
  worldSlug,
  userId,
}: {
  variant: 'any' | 'course-challenge'
  worldSlug: string
  userId: number
}): SQLFragment<LevelRequirementStatus> {
  return SQL<LevelRequirementStatus>`
       (
        CASE WHEN COUNT(CASE WHEN ${CertificationRequestQ.approved_at} IS NOT NULL THEN 1 END) > 0
            THEN ${LevelRequirementStatus.Complete}
            WHEN COUNT(CASE WHEN ${CertificationRequestQ.rejected_at} IS NULL THEN 1 END) > 0
            THEN ${LevelRequirementStatus.InProgress}
            ELSE ${LevelRequirementStatus.Incomplete}
            END
        )
      ${WorldQ.where({
        slug: worldSlug,
        include: [
          {
            association: 'Course',
            required: true,
            include: [
              {
                association: 'Topics',
                required: true,
                where:
                  variant === 'course-challenge' ? SQL`${TopicQ.type} = 'challenge'` : SQL`TRUE`,
                include: [
                  {
                    association: 'CertificationRequests',
                    required: true,
                    where: SQL`${CertificationRequestQ.user_id} = ${userId}`,
                  },
                ],
              },
            ],
          },
        ],
      })}
      `
}
